'use strict';
const angular = require('angular');

/*@ngInject*/
export function groupNameFilter() {
  return function (ids, groups) {
    let g = groups.filter(item => {
      return ids.indexOf(item._id) != -1;
    });
    return g = g.map(item => {
      return item.name;
    }).join(',');
  };
}


export default angular.module('updateServerApp.groupName', [])
  .filter('groupName', groupNameFilter)
  .name;



// WEBPACK FOOTER //
// ./client/app/filters/group-name.filter.js